"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _locationModal = require("./location-modal");
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* eslint new-cap: 0 */ /* global PSSessions, analyticsIntegrations */
var SearchMetroDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchMetroDropdown, _React$Component);
  function SearchMetroDropdown(props) {
    var _this;
    _classCallCheck(this, SearchMetroDropdown);
    _this = _callSuper(this, SearchMetroDropdown, [props]);
    _this.state = {
      ordered_metros: null
    };
    _this.getBrowserTimezoneOffset = _this.getBrowserTimezoneOffset.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.openLocationModal = _this.openLocationModal.bind(_assertThisInitialized(_this));
    _this.optionList = _this.optionList.bind(_assertThisInitialized(_this));
    _this.hightlightText = _this.hightlightText.bind(_assertThisInitialized(_this));
    _this.checkSelected = _this.checkSelected.bind(_assertThisInitialized(_this));
    _this.removeHovered = _this.removeHovered.bind(_assertThisInitialized(_this));
    _this.renderDropOptions = _this.renderDropOptions.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SearchMetroDropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var newMetros = nextProps.metros || [];
      var oldMetros = this.props.metros || [];
      if (newMetros.length > oldMetros.length) {
        var sortedMetros = _lodash.default.sortBy(nextProps.metros, function (m) {
          var difference = m.standard_tz_offset + _this2.getBrowserTimezoneOffset();
          return 0 > difference ? difference * -1 : difference;
        });
        this.setState({
          ordered_metros: sortedMetros
        });
      }
    }
  }, {
    key: "getBrowserTimezoneOffset",
    value: function getBrowserTimezoneOffset() {
      var currentDate = new Date();
      var gmtOffset = currentDate.getTimezoneOffset() / 60;
      return gmtOffset;
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(e) {
      var ignoreClickOutside = $(e.target).hasClass('ignore-clickoutside');
      if (this.props.enableClickOutside && !ignoreClickOutside) {
        this.props.closeDropdown();
        if (this.props.suggestions) {
          if (!$('#metro-list-0 a').hasClass('hovered')) {
            $('#metro-list-0 a').addClass('hovered');
          }
        }
      }
    }
  }, {
    key: "openLocationModal",
    value: function openLocationModal(e) {
      e.preventDefault();
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_locationModal.LocationModal, {
        metros: this.props.metros,
        handleLocationClick: this.props.clickFn,
        closeDropdown: this.props.closeDropdown,
        origin: this.props.origin,
        activityValue: this.props.activityValue,
        activityID: this.props.activityID
      }), document.getElementById('modal-container'));
    }
  }, {
    key: "optionList",
    value: function optionList(props) {
      var _React$createElement;
      return /*#__PURE__*/_react.default.createElement("li", (_React$createElement = {
        role: "presentation",
        key: props.index,
        id: "metro-list-".concat(props.index)
      }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_React$createElement, "role", "presentation"), "data-value", props.nickname), "data-geo", props.map_boundaries), "data-active", props.active), "data-placeid", props.place_id), "data-landing", props.landing_url), "data-name", props.name), "className", "border-bottom searchbar-metro-option"), "onClick", props.clickFn), "tabIndex", "-1"), _defineProperty(_React$createElement, "onFocus", this.removeHovered)), props.miscList ? /*#__PURE__*/_react.default.createElement("div", {
        className: "more-cities"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row-height"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 col-height col-middle ellipsis"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        onClick: this.openLocationModal
      }, props.number_remaining_metros, " more popular locations"))))) : /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        className: "".concat(props.selected, " ").concat(props.hovered)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row-height"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 col-height col-middle"
      }, props.highlighted_name)))));
    }
  }, {
    key: "hightlightText",
    value: function hightlightText(matchedSubstring, description) {
      var end = 0;
      matchedSubstring.map(function (match, i) {
        if (0 === i) {
          end = match.length;
        }
        end = match.offset + match.length;
      });
      var boldLetters = description.substring(0, end);
      var remainingLetters = description.substring(boldLetters.length, description.length);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ellipsis"
      }, /*#__PURE__*/_react.default.createElement("b", null, boldLetters), /*#__PURE__*/_react.default.createElement("span", {
        className: "text-gray"
      }, remainingLetters));
    }
  }, {
    key: "checkSelected",
    value: function checkSelected(optionProps) {
      var locationValue = this.props.locationValue;
      if (locationValue && locationValue === optionProps.name) {
        return 'dropdown-selected';
      }
    }
  }, {
    key: "removeHovered",
    value: function removeHovered() {
      $('#metro-list-0 a').removeClass('hovered');
    }
  }, {
    key: "renderDropOptions",
    value: function renderDropOptions(props) {
      var _this3 = this;
      var optionsArray = [];
      var metros = props.metros,
        suggestions = props.suggestions;
      if (suggestions) {
        optionsArray = suggestions.map(function (suggestion, i) {
          var description = suggestion.description,
            place_id = suggestion.place_id,
            matched_substrings = suggestion.matched_substrings;
          var hovered;
          if (0 === i) {
            hovered = 'hovered';
          }
          return {
            hovered: hovered || '',
            name: description,
            highlighted_name: _this3.hightlightText(matched_substrings, description),
            active: true,
            place_id: place_id
          };
        });
      } else {
        var selectedMetros = metros || [];
        if (this.state.ordered_metros) {
          selectedMetros = this.state.ordered_metros;
        }
        if (!this.props.all) {
          optionsArray = _lodash.default.take(selectedMetros, 4);
          optionsArray.push({
            miscList: true,
            number_remaining_metros: selectedMetros.length - optionsArray.length
          });
        } else {
          optionsArray = _lodash.default.filter(selectedMetros, {
            country: 'US'
          });
        }
      }
      return optionsArray.map(function (option, i) {
        var optionProps = option;
        optionProps.highlighted_name = option.highlighted_name || option.name;
        optionProps.clickFn = option.miscList ? null : _this3.props.clickFn;
        optionProps.index = i;
        optionProps.selected = _this3.checkSelected(optionProps);
        return _this3.optionList(optionProps);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        role: "menu",
        "aria-expanded": "false",
        onMouseEnter: this.removeHovered,
        className: "dropdown-menu city-dropdown"
      }, this.renderDropOptions(this.props), this.props.suggestions ? /*#__PURE__*/_react.default.createElement("li", {
        className: "text-center",
        style: {
          marginTop: 13,
          marginBottom: 13
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        style: {
          width: 150
        },
        src: "/web-templates/assets/images/powered_by_google.png?v=rb",
        alt: "powered by Google"
      })) : null);
    }
  }]);
  return SearchMetroDropdown;
}(_react.default.Component);
SearchMetroDropdown.propTypes = {
  all: _propTypes.default.bool,
  suggestions: _propTypes.default.array,
  metros: _propTypes.default.array,
  clickFn: _propTypes.default.func,
  locationValue: _propTypes.default.string,
  enableClickOutside: _propTypes.default.bool,
  closeDropdown: _propTypes.default.func,
  origin: _propTypes.default.string,
  activityValue: _propTypes.default.string,
  activityID: _propTypes.default.string
};
exports.SearchMetroDropdown = (0, _reactClickOutside.default)(SearchMetroDropdown);